var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.245 6.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1.001 1l-2.745-.004a1 1 0 1 1 .002-2h.184a3.1 3.1 0 0 0-1.448-.382c-2.3 0-3.737 1.944-3.737 3.561 0 1.618 1.437 3.562 3.737 3.562s3.737-1.944 3.737-3.562a1 1 0 0 1 2 0c0 2.593-2.207 5.562-5.737 5.562S6.5 15.268 6.5 12.675c0-2.592 2.207-5.561 5.737-5.561 1.166 0 2.184.424 3.008.993V7.5a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCircle);
export default __webpack_public_path__ + "static/media/refresh_circle.6ab2a26ddb88413bf4260ef77e613dda.svg";
export { ForwardRef as ReactComponent };